import * as types from "../types";

const initState = {
    finarkinURL: "",
    finarkeinStatus:"",
    surrogateList:[],
    surrogateStatus:"",
    posRequired:"",
    posCreditLimit:"",
    finalCreditLimit:"",
    gstnList:[],
    perfiosUrl:"",
    perfiosRedirectSts:"",
    epfoOtpGenResponse: null,
    epfoOtpGenErrorCode:null,
    blazeStpEligible:null,
    aaTriggerCount: null
};

const IncomeSurrogateReducer = (state = initState, action) => {
    switch (action.type) {
            case types.SAVE_FINARKIN_URL:
            return {
                ...state,
                finarkinURL: action.payload.url
            };
            case types.SAVE_FINARKEIN_STATUS:
                return {
                    ...state,
                finarkeinStatus: action.payload
                }
            case types.SAVE_SURROGATE_DATA:
                return {
                    ...state,
                    posRequired: action.payload.posRequired,
                    surrogateStatus:action.payload.surrogateStatus,
                    surrogateList:action.payload.surrogateList,
                    posCreditLimit:action.payload.posCreditLimit,
                    finalCreditLimit:action.payload.finalCreditLimit, 
                    gstnList:action.payload.gstnList, 
                    aaTriggerCount: action.payload.aaTriggerCount, 
                };
                case types.UPDATE_SURROGATE_LIST:
                    return {
                        ...state,
                        surrogateList:action.payload
                    };
            case types.SAVE_RESPONSE_SURGST_PERFIOS_URL:
                return {
                    ...state,
                    perfiosUrl: action.payload.url
                };  
            case types.SAVE_PERFIOS_REDIRECT_STATUS:
                return {
                    ...state,
                    perfiosRedirectSts: action.payload
                };  
            case types.SAVE_EPFO_OTP_GEN_RESPONSE:
                return {
                    ...state,
                    epfoOtpGenResponse: action.payload,
                };     
                case types.SET_EPFO_OTP_GEN_ERROR_CODE:
                    return {
                        ...state,
                        epfoOtpGenErrorCode: action.payload,
                    };
                    case types.SAVE_BLAZESTP_ELIGIBLE:
                        return {
                            ...state,
                            blazeStpEligible: action.payload,
                        };    
        default:
            return state;
    }
};

export default IncomeSurrogateReducer;
